<template>
  <FormItem :label="label" :required="required" :value="formData.fault_pic.length + '/9'" :border="border" />

  <div class="upload-view grid grid-cols-3 gap-15">
    <div v-for="(itemImg, imgIdx) in formData.fault_pic" :key="imgIdx" class="upload-item flex relative">
      <img
        v-if="imgType.includes(itemImg.file_type)"
        class="w-full h-full rounded-2"
        :src="itemImg.img_url"
        @click="handleImg(itemImg)"
      />

      <video v-else :src="itemImg.img_url" class="w-full h-full" @click="handleImg(itemImg)"></video>

      <div class="upload-delete absolute flex items-center" @click="deleteImg(imgIdx)">
        <img src="@/assets/common/delete-icon.png" alt="" />
      </div>
    </div>

    <van-uploader
      v-if="formData.fault_pic.length < 9"
      class="upload-btn upload-item"
      :accept="accept"
      multiple
      :max-count="9"
      :after-read="afterRead"
      :before-read="beforeRead"
    >
      <div class="upload-icon flex items-center justify-center rounded-2">
        <img src="@/assets/common/upload.png" />
      </div>
    </van-uploader>
  </div>

  <van-image-preview v-model:show="showImagePreview" :images="imageData.url" closeable>
    <template #image="{ src }">
      <video v-if="!imageData.type" style="width: 100%" controls autoplay>
        <source :src="src" />
      </video>
      <img v-else class="w-full h-full" :src="src" />
    </template>
  </van-image-preview>
</template>

<script setup>
import to from "await-to-js";
import { reactive, ref } from "vue";
import { Toast } from "vant";
import { repairService } from "@/service";
import { useCompressor, useBlobToBase64 } from "@/hooks/useCompressor.js";
import { vLoading } from "@/utils/loading";
import FormItem from "./FormItem.vue";

const emit = defineEmits(["change"]);

const props = defineProps({
  label: { type: String, default: "处理图片" },
  accept: { type: String, default: "image/*,video/*" },
  list: { type: Array, default: () => [] },
  required: { type: Boolean, default: false },
  border: { type: Boolean, default: true }
});

const formData = reactive({
  fault_pic: props.list
});

const beforeRead = async file => {
  if (file.type.includes("video")) {
    const url = URL.createObjectURL(file);
    const audioElement = new Audio(url);
    audioElement.muted = true;
    audioElement.play().then(() => audioElement.pause());

    return new Promise((resolve, reject) => {
      const isHas = formData.fault_pic.find(i => i.file_type.includes("mp4"));

      if (isHas) {
        Toast.fail("只能上传一个视频");
        reject();
      }

      audioElement.addEventListener("loadedmetadata", function() {
        const duration = parseInt(audioElement.duration);
        if (duration > 15) {
          audioElement.muted = false;
          Toast.fail("视频不能超过15S");
          reject();
        } else {
          audioElement.muted = false;
          resolve();
        }
      });
    });
  }
};
// 上传图片视频
const afterRead = async file => {
  const files = [].concat(file);
  try {
    files.forEach(async file => {
      const form = new FormData();

      if (file.file.type.includes("image")) {
        const compressFiles = await new Promise(resolve => {
          useCompressor(file.content, {
            quality: 0.6,
            success: resolve,
            error(err) {
              console.log(err.message);
            }
          });
        });
        const base64 = useBlobToBase64(compressFiles, file.file.name, file.file.type);
        form.append("my_files", base64);
      } else {
        form.append("my_files", file.file);
      }

      vLoading.start();
      const [error, data] = await to(repairService.saveImg(form));
      vLoading.stop();
      if (error) return;

      formData.fault_pic.push(data.data.data[0]);
      onChange();
    });
  } catch {}
};

const showImagePreview = ref(false);
const imageData = reactive({
  url: [],
  type: 0
});
const imgType = ["png", "jpg", "gif", "svg", "jpeg"];

const handleImg = item => {
  showImagePreview.value = true;
  Object.assign(imageData, {
    url: [item.img_url],
    type: imgType.includes(item.file_type)
  });
};

const deleteImg = idx => {
  formData.fault_pic.splice(idx, 1);
  onChange();
};

const onChange = () => {
  emit("change", formData.fault_pic);
};
</script>
<style lang="less" scoped>
.upload-view {
  margin-bottom: 15px;
  .upload-item {
    border: 1px dashed #fff;
    width: 105px;
    height: 105px;
    margin-right: 5px;
    margin-bottom: 5px;
    .upload-delete {
      right: -10px;
      top: -10px;
      width: 20px;
      height: 20px;

      & > img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .upload-btn {
    width: 105px;
    height: 105px;
    .upload-icon {
      border: 1px dashed #e1e3e5;
      width: 105px;
      height: 105px;
      & > img {
        width: 32px;
      }
    }
  }
}
</style>
